import { Activity } from 'lucide-react';

const formatDateTime = (dateString) => new Date(dateString).toLocaleString('fr-FR');
const getInitials = (name) => name.split(' ').map(n => n[0]).join('').toUpperCase();

const DashboardAttendanceCard = ({ t, recentPointages }) => (
  <div className="col-span-4 rounded-xl overflow-hidden" style={{ backgroundColor: "var(--lm-s1)", border: "1px solid var(--lm-border)" }}>
    <div className="flex items-center justify-between px-5 py-4" style={{ borderBottom: "1px solid var(--lm-border)" }}>
      <div>
        <h3 className="text-sm font-semibold" style={{ color: "var(--lm-ink)" }}>{t('attendance.title')}</h3>
        <p className="text-xs mt-0.5" style={{ color: "var(--lm-ink-2)" }}>{t('attendance.subtitle')}</p>
      </div>
      <Activity className="w-4 h-4" style={{ color: "#5e6ad2" }} />
    </div>

    <div className="overflow-x-auto">
      <table className="w-full">
        <thead>
          <tr style={{ borderBottom: "1px solid var(--lm-border)" }}>
            {[t('employees.fullName'), t('common.status'), t('common.date'), t('common.status')].map((col, i) => (
              <th key={i} className={`px-5 py-3 text-left text-xs font-medium ${i === 3 ? 'text-right' : ''}`}
                style={{ color: "var(--lm-ink-3)" }}>
                {col}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {recentPointages.length > 0 ? (
            recentPointages.map((p) => (
              <tr key={p.id} style={{ borderBottom: "1px solid var(--lm-border)" }}
                onMouseEnter={e => (e.currentTarget.style.backgroundColor = "var(--lm-s2)")}
                onMouseLeave={e => (e.currentTarget.style.backgroundColor = "transparent")}>
                <td className="px-5 py-3">
                  <div className="flex items-center gap-3">
                    <div className="w-7 h-7 rounded-lg flex items-center justify-center text-xs font-semibold flex-shrink-0"
                      style={{ backgroundColor: "rgba(94,106,210,0.15)", color: "#828fff" }}>
                      {getInitials(p.employee_name)}
                    </div>
                    <span className="text-sm font-medium" style={{ color: "var(--lm-ink)" }}>{p.employee_name}</span>
                  </div>
                </td>
                <td className="px-5 py-3">
                  <span className="text-xs px-2 py-0.5 rounded-full"
                    style={p.type === 'entree'
                      ? { backgroundColor: "rgba(39,166,68,0.12)", color: "var(--lm-success)" }
                      : { backgroundColor: "rgba(94,106,210,0.12)", color: "#828fff" }}>
                    {p.type === 'entree' ? t('attendance.checkIn') : t('attendance.checkOut')}
                  </span>
                </td>
                <td className="px-5 py-3 text-sm" style={{ color: "var(--lm-ink-2)" }}>{formatDateTime(p.timestamp)}</td>
                <td className="px-5 py-3 text-right">
                  <span className="text-xs px-2 py-0.5 rounded-full"
                    style={{ backgroundColor: "rgba(39,166,68,0.12)", color: "var(--lm-success)" }}>
                    {t('dashboard.validated')}
                  </span>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={4} className="py-16 text-center">
                <Activity className="w-8 h-8 mx-auto mb-3" style={{ color: "var(--lm-border-2)" }} />
                <p className="text-sm font-medium" style={{ color: "var(--lm-ink-2)" }}>{t('attendance.noAttendance')}</p>
                <p className="text-xs mt-1" style={{ color: "var(--lm-ink-3)" }}>{t('dashboard.recentActivity')}</p>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  </div>
);

export default DashboardAttendanceCard;
